import { useEffect } from 'react';

import useSelectionsD1ConferencesData from '../../state/selectionsD1Conferences/UseSelectionsD1ConferencesData';  

const useSelectionsD1ConferencesDropdown = () => {
  const { 
    selectionsD1ConferencesState, setSelectionsD1ConferencesState, getSelectionsD1Conferences } = useSelectionsD1ConferencesData();

  useEffect(() => {
    if (selectionsD1ConferencesState.isArrayLoading !== true 
      && selectionsD1ConferencesState.isArrayLoaded !== true) {
      const getSelectionsD1ConferencesPromise = getSelectionsD1Conferences();
      if (getSelectionsD1ConferencesPromise !== null) {
        getSelectionsD1ConferencesPromise.then((newState) => {
          if (newState !== null) {
            setSelectionsD1ConferencesState({
              ...newState,
              items: newState.arrayData.map(x => { return { id: x.hostOrgUnitId, name: x.orgUnitName }; }),
              areItemsLoaded: true
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionsD1ConferencesState]);

  return {
    selectionsD1ConferencesState
  };
};

export default useSelectionsD1ConferencesDropdown;